import { RouterType } from '@moonpig/web-core-routing'
import { ApplicableFilter, SearchFilter } from '../../services/types/services'

type Props = {
  router: RouterType | null
  selectedFilters: ApplicableFilter[]
  preAppliedFilters: SearchFilter[]
  department?: string
  mostRecentSearchTerm?: string
}

export const updateRoute = ({
  router,
  selectedFilters,
  department,
  preAppliedFilters,
  mostRecentSearchTerm,
}: Props) => {
  if (!router) return

  const { name, params } = router.getCurrentRoute<'content' | 'search'>()

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { page, filters, ...existingQuery } = params

  const updatedFilters = selectedFilters?.length
    ? selectedFilters
        .map(filter =>
          filter.__typename === 'IntegerFilter'
            ? `${filter.parent}:${filter.integerKey}`
            : `${filter.parent}:${filter.id}`,
        )
        .join('.')
    : undefined

  const hasASuggestionBeenApplied =
    preAppliedFilters?.length > 0 && preAppliedFilters.some(f => f.suggestion)

  const newParams = {
    ...existingQuery,
    ...(updatedFilters ? { filters: updatedFilters } : {}),
    ...(department ? { d: department.toLowerCase() } : {}),
    ...(hasASuggestionBeenApplied && name === 'search'
      ? {
          suggestion: (existingQuery as { suggestion?: string }).suggestion,
        }
      : {
          suggestion: undefined,
          q: mostRecentSearchTerm || (existingQuery as { q?: string }).q,
        }),
    smartRedirection: undefined,
  }

  return router.replace({
    name,
    params: newParams,
  })
}
